var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinSpaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.1367,
    r: 10,
    fill: "white",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.6315L4.69238 16.386V7.88965L12 3.64465L19.3077 7.88965V16.386L12 20.6315Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8911 13.9734C15.8911 11.7981 14.1421 11.2546 12.5629 10.8824C10.984 10.5102 10.5574 10.3105 10.5574 9.68088C10.5574 9.23768 10.9126 8.77982 11.9799 8.77982C12.89 8.77982 13.6014 9.15132 14.2408 9.80895L15.678 8.40701C14.7388 7.42122 13.6014 6.83398 12.0516 6.83398C10.0884 6.83398 8.49489 7.9498 8.49489 9.76691C8.49489 11.7408 9.77495 12.3283 11.6093 12.7569C13.4871 13.1861 13.8286 13.4722 13.8286 14.1158C13.8286 14.8741 13.2736 15.2033 12.0933 15.2033C11.1404 15.2033 10.2445 14.8741 9.54749 14.0584L8.11035 15.3463C8.86444 16.4621 10.3156 17.1634 11.9799 17.1634C14.6961 17.1634 15.8911 15.8746 15.8911 13.9734Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.5,
    y: 0.636719,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSpaces);
export default __webpack_public_path__ + "static/media/pin_spaces.fec67993646c8223ad7bd81ecfa77a6a.svg";
export { ForwardRef as ReactComponent };